import React from "react";
import { CheckCircle, AlertTriangle, ShieldAlert, Ban } from "lucide-react";

const StatusContaCard = ({ arrendatario, onCorrigirCredenciais }) => {
  if (!arrendatario) return null;

  const isErroLogin = arrendatario.status === "ERRO_LOGIN";
  // Sem franquia de distribuição contratada os nomes nunca são ativados no provedor
  const isSemFranquia = !isErroLogin && arrendatario.franquia === 0;
  const isAtivo = !isSemFranquia && arrendatario.status === "ATIVO";

  return (
    <div className="bg-white rounded-xl shadow-sm border border-border flex flex-col h-full">
      <div className="flex items-center gap-3 p-5 border-b border-border bg-slate-50 rounded-t-xl">
        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-sm">
          {isAtivo ? (
            <CheckCircle className="w-5 h-5 text-emerald-500" />
          ) : isErroLogin ? (
            <ShieldAlert className="w-5 h-5 text-red-500" />
          ) : isSemFranquia ? (
            <Ban className="w-5 h-5 text-red-500" />
          ) : (
            <AlertTriangle className="w-5 h-5 text-amber-500" />
          )}
        </div>
        <h2 className="text-base font-semibold text-foreground">Ativação das capturas</h2>
      </div>

      <div className="p-5 flex-1">
        <p className="text-sm text-muted-foreground mb-4">
          Verificação da ativação das capturas dos nomes configurados.
        </p>
        <div className="bg-slate-50 rounded-lg p-3">
          {isAtivo ? (
            <div className="flex items-center gap-2 text-sm text-emerald-600">
              <CheckCircle className="w-4 h-4" />
              <span>Conta ativa</span>
            </div>
          ) : isErroLogin ? (
            <div className="flex items-center gap-2 text-sm text-red-600">
              <ShieldAlert className="w-4 h-4" />
              <span>Erro nas credenciais de acesso ao ADV.</span>
            </div>
          ) : isSemFranquia ? (
            <div className="flex items-start gap-2 text-sm text-red-600">
              <Ban className="w-4 h-4 mt-0.5 shrink-0" />
              <span>
                Franquia de distribuição não contratada. Os nomes cadastrados não serão ativados
                até a contratação. Entre em contato com seu consultor.
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-sm text-amber-600">
              <AlertTriangle className="w-4 h-4" />
              <span>Ativação pendente</span>
            </div>
          )}
        </div>
      </div>

      <div className="p-5 border-t border-border">
        {isAtivo ? (
          <button className="w-full py-2 px-4 rounded-md bg-emerald-500 text-white text-sm font-medium cursor-not-allowed opacity-80" disabled>
            Ativo
          </button>
        ) : isErroLogin ? (
          <button
            className="w-full py-2 px-4 rounded-md bg-red-500 hover:bg-red-600 text-white text-sm font-medium transition-colors"
            type="button"
            onClick={onCorrigirCredenciais}
          >
            Corrigir dados de acesso
          </button>
        ) : isSemFranquia ? (
          <button className="w-full py-2 px-4 rounded-md bg-slate-300 text-slate-600 text-sm font-medium cursor-not-allowed" disabled>
            Sem franquia
          </button>
        ) : (
          <button className="w-full py-2 px-4 rounded-md bg-slate-300 text-slate-600 text-sm font-medium cursor-not-allowed" disabled>
            Pendente
          </button>
        )}
      </div>
    </div>
  );
};

export default StatusContaCard;
